var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showForm
    ? _c("system-messages", {
        attrs: { "msg-id": _vm.currentId, "view-mode": _vm.viewMode },
        on: { back: _vm.handleBackFromForm },
      })
    : _c(
        "div",
        { staticClass: "page-container" },
        [
          _c(
            "div",
            { staticClass: "top-bar" },
            [
              _c("div", { staticClass: "title-area" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("home.systemMessageConfigList"))),
                ]),
                _c("p", [_vm._v(_vm._s(_vm.$t("home.systemMessageDesc")))]),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleCreate },
                },
                [
                  _vm._v(
                    " + " + _vm._s(_vm.$t("home.createSystemMessage")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "search-card", attrs: { shadow: "never" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: {
                    model: _vm.searchForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.creationTime") } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: false,
                                  "default-time": ["00:00:00", "23:59:59"],
                                  "end-placeholder": _vm.$t("home.endTime"),
                                  "start-placeholder": _vm.$t("home.startTime"),
                                  "range-separator": "~",
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.timeValue,
                                  callback: function ($$v) {
                                    _vm.timeValue = $$v
                                  },
                                  expression: "timeValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.messageType") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.all"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.messageType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "messageType",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.messageType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.urgentAnnouncement"),
                                      value: 15,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.operationNotice"),
                                      value: 14,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.systemUpdate"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.normalNotice"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.title") } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  maxlength: 200,
                                  placeholder: _vm.$t("home.inputTitleKeyword"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "title", $$v)
                                  },
                                  expression: "searchForm.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.status") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.all"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "status", $$v)
                                    },
                                    expression: "searchForm.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.pendingPublish"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.enabled"),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.disabled"),
                                      value: 3,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.draft"),
                                      value: 4,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.system") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.all"),
                                    clearable: "",
                                  },
                                  on: { change: _vm.handleSystemTypeChange },
                                  model: {
                                    value: _vm.searchForm.systemType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "systemType",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.systemType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.allSystems"),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.expressSystem"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.providerSystem"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.receiveArea") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.selectArea"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.regionId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "regionId", $$v)
                                    },
                                    expression: "searchForm.regionId",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.all"),
                                      value: -1,
                                    },
                                  }),
                                  _vm._l(_vm.regionList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.zhName +
                                          "（" +
                                          item.puName +
                                          "）",
                                        value: item.id,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.receiveState") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.selectState"),
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.receiveStateList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "receiveStateList",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.receiveStateList",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.all"),
                                      value: "-1",
                                    },
                                  }),
                                  _vm._l(_vm.stateData, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.label,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.receiveSite") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.selectSite"),
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.receiveSiteList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "receiveSiteList",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.receiveSiteList",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("home.all"),
                                      value: -1,
                                    },
                                  }),
                                  _vm._l(_vm.siteList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.receiveUser") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.searchForm.systemType,
                                    placeholder: _vm.$t(
                                      "home.selectUserAccount"
                                    ),
                                    "remote-method": _vm.remoteSearchUser,
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    multiple: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  on: {
                                    change: function (val) {
                                      return _vm.handleSelectChange(
                                        "userList",
                                        val
                                      )
                                    },
                                    clear: _vm.handleClearUser,
                                  },
                                  model: {
                                    value: _vm.searchForm.receiveUserList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "receiveUserList",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.receiveUserList",
                                  },
                                },
                                _vm._l(_vm.userOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.username,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("home.creator") } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("home.pleaseChoose"),
                                    "remote-method": _vm.getUserManageOption,
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  on: {
                                    "visible-change":
                                      _vm.handleUserManageOption,
                                  },
                                  model: {
                                    value: _vm.searchForm.createUser,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "createUser",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.createUser",
                                  },
                                },
                                _vm._l(_vm.createrList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.realName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "27px" },
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v(_vm._s(_vm.$t("home.reset")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.enterSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("home.search")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "list-container" },
            [
              _c("div", { staticClass: "list-header" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("home.totalConfigs")) +
                      " " +
                      _vm._s(_vm.queryForm.total) +
                      " " +
                      _vm._s(_vm.$t("home.configsUnit"))
                  ),
                ]),
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.creationTime"),
                      prop: "createDate",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.messageType"),
                      prop: "typeName",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                class: [
                                  "custom-type-tag",
                                  _vm.getTypeTagClass(row.type),
                                ],
                              },
                              [_vm._v(" " + _vm._s(row.typeName) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("home.title"), "min-width": "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tooltip",
                              { attrs: { effect: "dark", placement: "top" } },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "4px",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("home.chinese")) +
                                            "：" +
                                            _vm._s(row.zhTitle) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.portuguese")) +
                                          "：" +
                                          _vm._s(row.title)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("div", { staticClass: "title-cell" }, [
                                  _c("div", { staticClass: "title-zh" }, [
                                    _vm._v(_vm._s(row.zhTitle)),
                                  ]),
                                  _c("div", { staticClass: "title-pt" }, [
                                    _vm._v(_vm._s(row.title)),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("home.status"), width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "span",
                              {
                                class: ["status-badge", "status-" + row.status],
                              },
                              [
                                row.status === 2
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-circle-check status-icon",
                                    })
                                  : row.status === 1
                                  ? _c("i", {
                                      staticClass: "el-icon-time status-icon",
                                    })
                                  : row.status === 4
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-document status-icon",
                                    })
                                  : row.status === 3
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-circle-close status-icon",
                                    })
                                  : _vm._e(),
                                _vm._v(" " + _vm._s(row.statusName) + " "),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.system"),
                      prop: "systemTypeName",
                      "show-overflow-tooltip": "",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.displayPosition"),
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "display-pos" }, [
                              _vm._v(
                                _vm._s(row.displayLocatNameList.join(","))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.userEnd"),
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.userTypeName || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.userRange"),
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.receptTypeName || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.receiveAreaCount"),
                      align: "center",
                      "show-overflow-tooltip": "",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.receiveAreaName || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.receiveStateCount"),
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.receiveStateCount || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.receiveSiteCount"),
                      align: "center",
                      "show-overflow-tooltip": "",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.receiveSiteCount || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.receiveUserCount"),
                      align: "center",
                      "show-overflow-tooltip": "",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.receiveUserCount || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.publishTime"),
                      align: "center",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.effectiveTime || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.expirationTime"),
                      align: "center",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(" " + _vm._s(row.failureTime || "--") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.creator"),
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(row.createUserName || "--") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.operation"),
                      align: "center",
                      fixed: "right",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(row)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("home.view")) + " ")]
                            ),
                            row.status === 1 || row.status === 4
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("home.edit")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            row.status === 1 || row.status === 2
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { size: "small", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.disableData(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("home.disable")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-footer" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.queryForm.pageNumber,
                      "page-size": _vm.queryForm.pageSize,
                      "page-sizes": [10, 50, 100, 500, 1000],
                      total: _vm.queryForm.total,
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }